import React, { memo } from 'react';
import { Cell, Row } from '@dexma/ui-components';
import { StyledWidgetSelector } from 'adapter/in/common/components/Selector/style';

import gtmIds from 'adapter/in/dashboards/config/gtm';
import { StyledFieldGroup, StyledFieldGroupCell } from 'adapter/in/common/components/FieldGroup/style';
import { SelectorOption, SelectorValueOptions } from 'adapter/in/common/form/types';
import { FooterInputText } from 'adapter/in/common/components/Text';

export type WidgetFieldGroup = {
    label: string;
    name: string;
    options: SelectorOption[];
    value: SelectorValueOptions | undefined;
    isLoading: boolean;
    error: boolean;
    onChange: (data: any) => void;
    errorMessage?: string;
    variant: string;
    style?: React.CSSProperties;
    footer?: string;
};

const loadingOptions = [
    { value: 'no', label: 'd', id: 'd', disabled: true },
    { value: 'no', label: 'h', id: 'h', disabled: true },
    { value: 'no', label: 'm', id: 'm', disabled: true },
];
const getSelectedValues = (value: SelectorValueOptions) =>
    Array.isArray(value) ? value?.map((element) => element.id)[0] : ((value as unknown) as SelectorOption).id;

const FormFieldGroup = memo((props: WidgetFieldGroup) => {
    const { label, onChange, options, value, isLoading, error, errorMessage, name, variant, style, footer } = props;
    // eslint-disable-next-line no-nested-ternary
    const selectedValues = value ? getSelectedValues(value) : '';
    return (
        <StyledWidgetSelector error={!isLoading && error} data-testid='field-group-wrapper' style={style}>
            <Row>
                <Cell className='widget-type-block'>
                    <span>{label}</span>
                </Cell>
            </Row>
            <Row>
                <StyledFieldGroupCell>
                    <StyledFieldGroup
                        name={name}
                        variant={variant}
                        className={`field_group_${name}`}
                        dataId={`${gtmIds.addWidget.sidePanel.form.select}.${label?.replaceAll(' ', '_').toLowerCase()}`}
                        type='radio'
                        onChange={onChange}
                        isLoading={isLoading}
                        selectedValues={isLoading ? loadingOptions : selectedValues}
                        values={isLoading ? loadingOptions : options}
                    />
                    {!isLoading && error && <div className='error'>{errorMessage} </div>}
                </StyledFieldGroupCell>
            </Row>
            {footer && <FooterInputText text={footer} />}
        </StyledWidgetSelector>
    );
});

export default FormFieldGroup;
